import { CustomScrollBehaviorCallback } from 'scroll-into-view-if-needed/typings/types';
export const getAxiosErrorMessage = (error: any) => {
  return (
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString() ||
    'Lỗi không xác định!'
  );
};
export const addCommaToNumber = (number: number) => {
  return `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const addDotToNumber = (number?: number) => {
  return `${number}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const genCustomBehaviorScroll = () => {
  const behavior: CustomScrollBehaviorCallback<any> = (actions) =>
    // list is sorted from innermost (closest parent to your target) to outermost (often the document.body or viewport)
    actions.forEach(({ el, top, left }) => {
      // implement the scroll anyway you want
      el.scrollTop = top - 150; // 150 to fix header overide first error element
      el.scrollLeft = left;
    });
  return behavior;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  return (
    phoneNumber.substring(0, 3) +
    ' ' +
    phoneNumber.substring(3, 6) +
    ' ' +
    phoneNumber.substring(6)
  );
};

/**
 * Tiếng việt không dấu
 */
export function normalizeVietnameseNFD(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();
}

export * from './handleAxiosError';
export * from './base64ToBlob';
export * from './work-time';
export * from './objectPick';
export * from './FilterFormData';
